import React from 'react';
import styles from './Terms.module.css';

const Terms: React.FC = () => {
  return (
    <div className={styles.termsContainer}>
      <div className={styles.termsContent}>
        <h2 className={styles.termsHeader}>
          <i className="bi bi-file-text me-3"></i>
          Terms and Conditions
        </h2>
        
        <div className={styles.termsSection}>
          <p className={styles.effectiveDate}>Effective date: May 17, 2025</p>
          <p>
            These Terms of Service ("Terms") govern your access to and use of Valolens.com ("Service"), a comprehensive Valorant match analytics service provided by Juhakiili Oy ("Company" or "we"), registered in Finland at Välilausteentie 9, 21350 Ilmarinen, FIFPRO.2398119-8.
          </p>
          <p>
            Please read these Terms carefully. By accessing or using the Service, you agree to be bound by these Terms and any amendments to them. If you do not agree to these Terms, you must not use the Service.
          </p>
        </div>

        <div className={styles.termsSection}>
          <h3>1. Valolens.com Account</h3>
          <p>
            To use our premium features, you must create a Valolens.com account ("Account"). By creating an Account, you agree that all provided information is accurate, current, and complete. You also agree to promptly notify us of any changes to your information. It's your responsibility to keep your Account information up to date. You agree that your use of the Service will comply with all applicable laws and regulations. Each user account is personal, and the sharing of login credentials is not permitted.
          </p>
        </div>

        <div className={styles.termsSection}>
          <h3>2. Service Updates</h3>
          <p>
            The Service may be updated periodically, including the addition of new features. We cannot guarantee that these updates will be compatible with your existing Account. New features may apply to other product categories or newly launched products. Temporary beta-access may be granted for new features. You may switch or change subscriptions to access new features, but if you choose to downgrade, no refunds will be given for any remaining time on your previous subscription. If you decide to cancel your premium subscription, it will remain active until the end of the current monthly period.
          </p>
        </div>

        <div className={styles.termsSection}>
          <h3>3. Copyright</h3>
          <p>
            You may not reproduce, communicate, or use any of the content on our website without written permission from us. The Service is intended for use by professional teams and for educational purposes, but you are not permitted to sell or commercialise any content from the Service.
          </p>
        </div>

        <div className={styles.termsSection}>
          <h3>4. Subscription and Cancellation</h3>
          <p>
            Your subscription will be automatically billed at the beginning of each monthly period until you cancel. By agreeing to these Terms, you authorize us to charge your payment method for the next subscription term. You may cancel your subscription at any time, but we do not offer refunds for any remaining period. If you decide to cancel your subscription, it will remain active until the end of the current monthly period. If your Account becomes inactive, we reserve the right to delete your data.
          </p>
        </div>

        <div className={styles.termsSection}>
          <h3>5. Fair Use and Abuse</h3>
          <p>
            You must use our Service in a way that does not disrupt the service for other users. If you do not adhere to our fair-use policy, we may terminate your Account.
          </p>
        </div>

        <div className={styles.termsSection}>
          <h3>6. Passwords and Account Access</h3>
          <p>
            You are responsible for maintaining the security of your Account information, including your username and password. We may terminate your Account or place it on hold to protect you, or ourselves, from abuse.
          </p>
        </div>

        <div className={styles.termsSection}>
          <h3>7. Exclusion of Warranties</h3>
          <p>
            The Service is provided "as is", without any warranties. Your use of the Service is at your own risk. We do not guarantee that the Service will meet your needs, or that its operation will be uninterrupted or error-free.
          </p>
        </div>

        <div className={styles.termsSection}>
          <h3>8. Indemnification</h3>
          <p>
            You agree to indemnify and hold us harmless from any liability or costs related to your use of the Service or your breach of these Terms.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms; 